import { createAsyncThunk } from "@reduxjs/toolkit";
import { opportunitiesApi } from "../../http";
import { Notification, NotificationType, Opportunity, OpportunityType } from "../../types";
import { AppPage } from "../../types/app-page.type";
import { AppRefreshStatus } from "../../types/app-refresh-status.type";
import { appActions } from "../app/app.state";
import { getCompaniesStatusCountsAction } from "../companies/companies.effects";
import { notificationsActions } from "../notifications/notifications.state";
import { RootState } from "../store";
import listenerMiddleware from "../store/middlewares/listener.middleware";
import { OffersState } from "./offers.state";
import { OffersFilters } from "./types/offers-filters.type";

export const getOffersAction = createAsyncThunk(
    'offers/getOffers',
    async ({ page, pageSize, filters }: { page?: number, pageSize?: number, filters?: Partial<OffersFilters> }, thunk) => {
        const offersState: OffersState = (<RootState>thunk.getState()).offers;
        page = page ?? offersState.pagination.page;
        pageSize = pageSize ?? offersState.pagination.pageSize;
        filters = {
            ...offersState.filters,
            ...(filters || {})
        };
        const paginatedOffers = await opportunitiesApi.getOpportunities({
            from: page * pageSize,
            take: pageSize,
            filters: JSON.stringify({
                ...filters,
                type: OpportunityType.Offer
            })
        });
        return { paginatedOffers, page, pageSize, filters: <OffersFilters>filters };
    }
)

export const getOffersStatusCountsAction = createAsyncThunk(
    'offers/getOffersStatusCounts',
    async ({ changeRefresh }: { changeRefresh: boolean }, thunk) => {
        try {
            changeRefresh && thunk.dispatch(appActions.changeRefresh({
                status: AppRefreshStatus.InProgress,
                page: AppPage.Offers
            }));
            const response = await opportunitiesApi.getOpportunitiesStatusCounts(OpportunityType.Offer);
            return response;
        } finally {
            changeRefresh && thunk.dispatch(appActions.changeRefresh({
                status: AppRefreshStatus.Idle,
                page: AppPage.Offers
            }));
        }
    }
)

listenerMiddleware.startListening({
    actionCreator: notificationsActions.notificationReceived,
    effect: (action, listenerApi) => {
        const notification = action.payload as Notification<{ opportunity: Opportunity }>;
        if (notification?.type === NotificationType.OpportunityUnderReview &&
            notification?.payload?.opportunity?.type === OpportunityType.Offer) {
            listenerApi.dispatch(getOffersAction({}));
            listenerApi.dispatch(getOffersStatusCountsAction({ changeRefresh: false }));
        }
    }
})